import {useEffect, useState} from 'react';
import throttle from 'lodash/throttle';
import {DEBOUNCE_DELAY} from 'core/constants';

export const useScroll = (scrollPosition: number, debounceDelay = DEBOUNCE_DELAY): boolean => {
    const [isScrolled, setIsScrolled] = useState<boolean>(false);

    useEffect(() => {
        const handlePageScroll = throttle(() => {
            setIsScrolled(window.scrollY >= scrollPosition);
        }, debounceDelay);

        window.addEventListener('scroll', handlePageScroll);

        // eslint-disable-next-line consistent-return
        return () => {
            window.removeEventListener('scroll', handlePageScroll);
            if ((handlePageScroll as any).cancel) {
                (handlePageScroll as any).cancel();
            }
        };
    }, [scrollPosition, debounceDelay]);

    return isScrolled;
};
